import { render, staticRenderFns } from "./EditHeatmapOrGridDataContainer.vue?vue&type=template&id=8c11edd6&"
import script from "./EditHeatmapOrGridDataContainer.vue?vue&type=script&lang=js&"
export * from "./EditHeatmapOrGridDataContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/HistomicsUI/histomicsui/web_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c11edd6')) {
      api.createRecord('8c11edd6', component.options)
    } else {
      api.reload('8c11edd6', component.options)
    }
    module.hot.accept("./EditHeatmapOrGridDataContainer.vue?vue&type=template&id=8c11edd6&", function () {
      api.rerender('8c11edd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@girder/histomicsui/vue/components/EditHeatmapOrGridDataContainer.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/vue/components/EditHeatmapOrGridDataContainer.vue
// module id = 62
// module chunks = 0